import {initialState} from '@ispm-client/modules/bpmn-modeler/store/state';
import {BpmnProcessCreatorActionTypes, BpmnSaveActions} from '@ispm-client/modules/bpmn-modeler/store/actions';
import {SaveParams} from '@ispm-client/modules/bpmn-modeler/models/save-params';


export function saveParams(state = initialState.saveParams, action: BpmnSaveActions): SaveParams {
  switch (action.type) {
    case BpmnProcessCreatorActionTypes.SAVE_BPMN: {
      return action.payload;
    }
    default: {
      return state;
    }
  }
}
